import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Terminal } from 'lucide-react';
import { AppLayout } from '@/components/layout/AppLayout';
import { JobProfileForm } from '@/components/jobProfile/JobProfileForm';
import { ProfileList } from '@/components/jobProfile/ProfileList';
import type { JobProfile } from '@/types/jobProfile';

export function ProfilesPage() {
 const navigate = useNavigate();
 const [view, setView] = useState<'list' | 'create'>('list');

 const handleCreateNew = () => {
  setView('create');
 };

 const handleFormSuccess = () => {
  setView('list');
 };

 const handleStartInterview = (profile: JobProfile) => {
  const sessionId = crypto.randomUUID();
  navigate(`/interview/${sessionId}?jobProfileId=${profile.id}`);
 };

 const handleEditProfile = (profile: JobProfile) => {
  // TODO: Open edit form with profile data
  console.log('Editing profile:', profile.id);
 };

 return (
  <AppLayout>
   {/* Sub-navigation for create flow */}
   {view === 'create' && (
    <div className='mb-8'>
     <Button
      variant='ghost'
      size='sm'
      onClick={() => setView('list')}
      className='text-muted-foreground hover:text-foreground font-mono text-xs rounded-none pl-0'
     >
      <ArrowLeft className='w-4 h-4 mr-2' />
      BACK TO INTERVIEWS
     </Button>
    </div>
   )}

   {/* Main Content */}
   <div>
    {view === 'list' ? (
     <ProfileList
      onCreateNew={handleCreateNew}
      onStartInterview={handleStartInterview}
      onEdit={handleEditProfile}
     />
    ) : (
     <div className='space-y-8'>
      <div className='border-b border-border pb-8'>
       <div className='flex items-center gap-2 mb-2'>
        <Terminal className='w-4 h-4 text-primary' />
        <span className='font-mono text-xs text-primary'>NEW SESSION</span>
       </div>
       <h1 className='text-3xl font-bold text-foreground mb-2 tracking-tight font-mono'>
        CREATE NEW PROFILE
       </h1>
       <p className='text-muted-foreground font-mono text-sm max-w-2xl'>
        Enter job details to configure your personal interview assistant.
       </p>
      </div>
      <JobProfileForm onSuccess={handleFormSuccess} />
     </div>
    )}
   </div>
  </AppLayout>
 );
}
